export class Constants {
  public static GenericError: string = "Wystąpił błąd. Proszę skontaktować się z Administratorem.";
}
